import { createTheme } from '@mui/material/styles';
import { bgBG } from '@mui/x-data-grid';
import { bgBG as coreBgBG } from '@mui/material/locale';
import {
  palette,
  shadows,
  spacing,
  typography,
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails,
  MuiAvatar,
  MuiBackdrop,
  MuiBadge,
  MuiBreadcrumbs,
  MuiButton,
  MuiButtonBase,
  MuiLoadingButton,
  MuiButtonGroup,
  MuiCalendarOrClockPicker,
  MuiCalendarPicker,
  MuiCardContent,
  MuiCheckbox,
  MuiChip,
  MuiDataGrid,
  MuiDayPicker,
  MuiDialog,
  MuiDialogContent,
  MuiDialogTitle,
  MuiDialogActions,
  MuiDivider,
  MuiDrawer,
  MuiFormControl,
  MuiIconButton,
  MuiInput,
  MuiFilledInput,
  MuiOutlinedInput,
  MuiInputAdornment,
  MuiInputLabel,
  MuiLink,
  MuiPaper,
  MuiPickersCalendarHeader,
  MuiPickersDay,
  MuiPickerStaticWrapper,
  MuiSelect,
  MuiMenuItem,
  MuiSkeleton,
  MuiTabs,
  MuiTab,
  MuiTypography,
  MuiTooltip,
  MuiTable,
  MuiTableCell,
  MuiTableFooter,
  MuiTableHead,
  MuiTableRow,
} from './components';

import 'typeface-hk-grotesk-cyrillic';

// ref: https://mui.com/material-ui/customization/default-theme/
// ref: https://mdigi.tools/darken-color/#1a73e7

export const theme: any = {
  palette,
  typography,
  shadows,
  spacing,
  components: {
    MuiDrawer,
    MuiCheckbox,
    // accordion -->
    MuiAccordion,
    MuiAccordionSummary,
    MuiAccordionDetails,
    // end accordion
    MuiAvatar,
    MuiBackdrop,
    MuiBadge,
    MuiBreadcrumbs,
    MuiButton,
    MuiButtonBase,
    MuiLoadingButton,
    MuiButtonGroup,
    // calendar -->
    MuiCalendarOrClockPicker,
    MuiCalendarPicker,
    MuiDayPicker,
    MuiPickersCalendarHeader,
    MuiPickersDay,
    MuiPickerStaticWrapper,
    // end calendar
    // card -->
    MuiCardContent,
    // end card
    MuiChip,
    MuiDataGrid,
    // dialog -->
    MuiDialog,
    MuiDialogActions,
    MuiDialogContent,
    MuiDialogTitle,
    // end dialog
    MuiDivider,
    MuiFormControl,
    MuiIconButton,
    // input -->
    MuiInput,
    MuiFilledInput,
    MuiOutlinedInput,
    MuiInputAdornment,
    MuiInputLabel,
    // end input
    MuiSelect,
    MuiSkeleton,
    MuiLink,
    MuiMenuItem,
    MuiPaper,
    // tabs -->
    MuiTabs,
    MuiTab,
    // end tabs
    MuiTooltip,
    MuiTypography,
    //table
    MuiTable,
    MuiTableCell,
    MuiTableFooter,
    MuiTableHead,
    MuiTableRow,
  },
};

export default createTheme(theme, bgBG, coreBgBG);
